// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3NHlJ","col":"styles_col__34O0b"};